<button class="day-calendar-btn" ion-button small [ngClass]="classes" *ngIf="!disabled" (click)="selectDay()">{{
	number}}</button>

<button class="day-calendar-btn disabled" ion-button small [ngClass]="classes" *ngIf="disabled">{{
	number}}</button>